import { LightboxOptions, useLightbox } from '@mangoweb/react-fslightbox'
import Image from 'next/legacy/image'
import type { ImageResult } from '../data/fragments/ImageFragment'
import styles from './Comments.module.sass'

export type GalleryProps = {
	id?: string
	items: Array<{
		image?: ImageResult
	}>
}

export function Gallery(props: GalleryProps) {
	const options: LightboxOptions = {}

	const lightbox = useLightbox(
		props.items.map((item) => ({
			source: String(item.image?.url),
			type: 'image',
			caption: item.image?.description ? item.image?.description : '',
		})),
		options
	)

	return (
		<div className={styles.commentImages}>
			<h4>Results photos:</h4>
			{props.items.map((image, i) => {
				return (
					<button
						onClick={() => {
							lightbox?.open(i)
						}}
						key={i}
						className={styles.commentImagesSingle}>
						{image.image?.url && (
							<Image
								src={image.image?.url}
								layout="fill"
								objectFit="cover"
								alt={image.image?.alt ?? image.image?.description ?? ''}
								placeholder="blur"
								blurDataURL={image.image?.url}
							/>
						)}
					</button>
				)
			})}
		</div>
	)
}
